import http from "../http-common";

class ConversionDataService {
  getAll() {
    return http.get("/conversions");
  }

  getByCondition(filter, value) {
    return http.get(`/conversions/${filter}/${value}`);
  }

  get(id) {
    return http.get(`/conversions/${id}`);
  }

  create(data) {
    return http.post("/conversions", data);
  }

  delete(id) {
    return http.delete(`conversions/${id}`);
  }

  bulkCreate(data) {
    return http.post(`/conversions/bulk`, data);
  }

  update(id, data) {
    return http.put(`/conversions/${id}`, data);
  }
  
}

export default new ConversionDataService();
